import { createSlice } from '@reduxjs/toolkit';
import ArcadaApiService from 'helpers/service/arcadaApiService';
import { FormatErrorResponse } from 'utils/formatErrorResponse';
import { dispatch } from '../store';

import { slice as globalNotificationSlice } from './globalNotifications';
import { TABLE_ROWS_COUNT_OPTIONS_MAX } from '../../utils/table';

const initialState = {
  isLoading: false,
  isLoadingSingle: false,
  notifications: null,
  error: null,
  currentNotification: null,
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    startLoadingSingle(state) {
      state.isLoadingSingle = true;
    },
    getEntitiesSuccess(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
    },
    getEntitySuccess(state, action) {
      state.isLoadingSingle = false;
      state.currentNotification = action.payload;
    },
    updateEntitySuccess(state, action) {
      state.isLoadingSingle = false;
      if (state.notifications) {
        const index = state.notifications.data.findIndex((n) => n.id === action.payload.id);
        if (index !== -1) {
          state.notifications.data[index] = action.payload;
        }
      }
    },
    deleteEntitySuccess(state, action) {
      state.isLoading = false;
      if (state.notifications) {
        state.notifications.data = state.notifications.data.filter((n) => n.id !== action.payload);
        state.notifications.totalCount -= 1;
      }
    },
    hasError(state, action) {
      state.isLoading = false;
      state.isLoadingSingle = false;
      state.isNotificationReceiversLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;
export const { actions } = slice;

export function getNotifications(
  skip = 0,
  take = TABLE_ROWS_COUNT_OPTIONS_MAX[0],
  order = 1,
  ordering = 'created_at',
  search,
  filters
) {
  const data = { skip, take, ordering, ordering_desc: order, search, ...filters };

  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await ArcadaApiService.notification.getNotifications(data);
      dispatch(slice.actions.getEntitiesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(globalNotificationSlice.actions.hasNotification(FormatErrorResponse(error)));
    }
  };
}

export function getNotification(id) {
  return async () => {
    dispatch(slice.actions.startLoadingSingle());

    try {
      const response = await ArcadaApiService.notification.getNotification(id);
      dispatch(slice.actions.getEntitySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(globalNotificationSlice.actions.hasNotification(FormatErrorResponse(error)));
    }
  };
}

export function updateNotification(id, data) {
  return async () => {
    dispatch(slice.actions.startLoadingSingle());

    try {
      const response = await ArcadaApiService.notification.updateNotification(id, data);
      dispatch(slice.actions.updateEntitySuccess(response.data));
      dispatch(globalNotificationSlice.actions.hasNotification({
        type: 'success',
        message: 'Ծանուցումը հաջողությամբ թարմացվեց'
      }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(globalNotificationSlice.actions.hasNotification(FormatErrorResponse(error)));
    }
  };
}

export function deleteNotification(id) {
  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      await ArcadaApiService.notification.deleteNotification(id);
      dispatch(slice.actions.deleteEntitySuccess(id));
      dispatch(globalNotificationSlice.actions.hasNotification({
        type: 'success',
        message: 'Ծանուցումը հաջողությամբ ջնջվեց'
      }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(globalNotificationSlice.actions.hasNotification(FormatErrorResponse(error)));
    }
  };
}
